import { useContent } from '../../../../hooks/use-server-content';

export interface VideoContentProps {
    hide: boolean;
    videoTitle: string;
    videoDescription: string;
    videoId: string;
    accountId: string;
}

export const useVideoContent = (
    category: string,
    name: string
): VideoContentProps | null => {
    const [content, getValueByName] = useContent(category, name);
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide || !contentFragment.videoTitle) {
            contentFragment = null;
        }
    }

    return contentFragment as VideoContentProps;
};
